<p-card [styleClass]="'login-card' + (isShaking ? ' shake' : '')">
  <ng-template pTemplate="header">
    <div class="login-header">
      <img alt="Nousmedis" src="/assets/img/logo-catalogcloud-dark.svg" />
    </div>
  </ng-template>

  <ng-template pTemplate="content">
    <!-- Formulario de login -->
    <div
      *ngIf="loginForm && !showResetPass"
      [formGroup]="loginForm"
      class="login-fields"
    >
      <!-- Campo email / username -->
      <div class="login-field">
        <label for="username">{{ 'USER.USERNAME' | translate }}</label>
        <input
          id="username"
          pInputText
          type="email"
          formControlName="username"
          [attr.aria-describedby]="fieldHasError('username') ? 'username-error' : null"
          [attr.aria-invalid]="fieldHasError('username') || null"
          [class.ng-invalid]="fieldHasError('username')"
          [class.ng-touched]="loginForm.get('username')!.touched"
        />
        <small
          *ngIf="fieldError('username', 'required')"
          id="username-error"
          class="p-error"
        >
          {{ 'USER.VALIDATION.EMAIL_REQUIRED' | translate }}
        </small>
        <small
          *ngIf="fieldError('username', 'email')"
          id="username-error"
          class="p-error"
        >
          {{ 'USER.VALIDATION.EMAIL_FORMAT' | translate }}
        </small>
      </div>

      <!-- Campo contraseña -->
      <div class="login-field">
        <label for="password">{{ 'USER.PASSWORD' | translate }}</label>
        <p-password
          inputId="password"
          formControlName="password"
          [feedback]="false"
          [toggleMask]="true"
          styleClass="w-full"
          [inputStyleClass]="fieldHasError('password') ? 'ng-invalid ng-touched' : ''"
          [attr.aria-describedby]="fieldHasError('password') ? 'password-error' : null"
        ></p-password>
        <small
          *ngIf="fieldError('password', 'required')"
          id="password-error"
          class="p-error"
        >
          {{ 'USER.VALIDATION.PASSWORD_REQUIRED' | translate }}
        </small>
        <small
          *ngIf="fieldError('password', 'minlength')"
          id="password-error"
          class="p-error"
        >
          {{ 'USER.VALIDATION.PASSWORD_MIN_LENGTH' | translate }}
        </small>
      </div>

      <!-- Recuérdame -->
      <div class="login-remember">
        <p-checkbox
          formControlName="remember"
          [binary]="true"
          inputId="remember"
        ></p-checkbox>
        <label for="remember">{{ 'USER.REMEMBER_ME' | translate }}</label>
      </div>
    </div>

    <!-- Formulario recuperar contraseña -->
    <div *ngIf="showResetPass" class="login-fields">
      <div class="login-field">
        <label for="forgot-email">{{ 'USER.FORGOT_PASSWORD_EMAIL' | translate }}</label>
        <input
          id="forgot-email"
          pInputText
          type="email"
          [(ngModel)]="mailforgotten"
          [placeholder]="'USER.EMAIL_PLACEHOLDER' | translate"
        />
      </div>
    </div>
  </ng-template>

  <ng-template pTemplate="footer">
    <!-- Acciones login -->
    <div *ngIf="!showResetPass" class="login-actions">
      <p-button
        styleClass="login-btn-primary"
        [raised]="true"
        [loading]="isLoading"
        [disabled]="isLoading"
        (onClick)="onLogin()"
      >
        {{ 'USER.START_SESSION' | translate }}
      </p-button>
      <p-button
        styleClass="login-btn-forgot"
        [raised]="false"
        [text]="true"
        [disabled]="isLoading"
        (onClick)="showResetPass = true"
      >
        {{ 'USER.FORGOT_PASSWORD' | translate }}
      </p-button>
    </div>

    <!-- Acciones recuperar contraseña -->
    <div *ngIf="showResetPass" class="reset-actions">
      <p-button
        [text]="true"
        severity="secondary"
        (onClick)="showResetPass = false"
      >
        {{ 'USER.CANCEL' | translate }}
      </p-button>
      <p-button
        [raised]="true"
        [disabled]="!mailforgotten"
        (onClick)="onForgotPassword()"
      >
        {{ 'USER.SEND' | translate }}
      </p-button>
    </div>
  </ng-template>
</p-card>
